import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, MapPin, Calendar, ArrowRight } from "lucide-react";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { EmptyState, LoadingState, ErrorState } from "../../components/shared/EmptyState";
import { studentNav } from "../../components/shared/navConfig";
import { useApi, inr, fmtDate } from "../../lib/useApi";

export default function StudentAllocated() {
  const { data, loading, error, reload } = useApi("/workrooms/mine");
  const rooms = data || [];
  return (
    <DashboardShell nav={studentNav} title="Allocated tasks" subtitle="Tasks the admin has allocated to you">
      <div className="card-surface p-4 sm:p-5">
        {loading ? <LoadingState/> : error ? <ErrorState message={error} onRetry={reload}/> : !rooms.length ? (
          <EmptyState icon={Briefcase} title="No allocated tasks yet" desc="Apply to live tasks — once admin allocates one to you it appears here with its workroom." cta="Find tasks" to="/student/tasks" testId="allocated-empty"/>
        ) : (
          <div className="grid md:grid-cols-2 gap-3">
            {rooms.map(r => (
              <div key={r.workroom_id} data-testid={`allocated-card-${r.workroom_id}`} className="p-4 rounded-lg border" style={{ borderColor: "var(--border)", background: "var(--surface)" }}>
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <div className="text-sm font-medium truncate" style={{ color: "var(--text)" }}>{r.task?.title || r.task_id}</div>
                    <div className="text-xs mt-0.5" style={{ color: "var(--text-dim)" }}>{r.task?.company_name} · <span className="font-mono">{r.task_id}</span></div>
                  </div>
                  <StatusBadge status={r.status}/>
                </div>
                <div className="grid grid-cols-3 gap-2 mt-3 text-xs" style={{ color: "var(--text-muted)" }}>
                  <span className="inline-flex items-center gap-1 truncate"><MapPin size={11}/>{r.task?.work_mode === "Remote" ? "Remote" : (r.task?.city || "—")}</span>
                  <span className="font-mono" style={{ color: "var(--text)" }}>{inr(r.task?.budget)}</span>
                  <span className="inline-flex items-center gap-1"><Calendar size={11}/>{r.task?.deadline || fmtDate(r.created_at)}</span>
                </div>
                <Link to={`/workroom?id=${r.workroom_id}`} data-testid={`open-workroom-${r.workroom_id}`} className="btn-primary mt-4 w-full py-2.5 rounded-md text-xs inline-flex items-center justify-center gap-2">
                  Open workroom <ArrowRight size={12}/>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardShell>
  );
}
